import { render, staticRenderFns } from "./TripleTableThreeColumns.vue?vue&type=template&id=00cf1085"
import script from "./TripleTableThreeColumns.vue?vue&type=script&lang=js"
export * from "./TripleTableThreeColumns.vue?vue&type=script&lang=js"
import style0 from "./TripleTableThreeColumns.vue?vue&type=style&index=0&id=00cf1085&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports